import React, { useEffect, useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import fetch from "logic/rest/FetchProvider";
import FormAdvancedOptions from "./FormAdvancedOptions";
import { ApiRoutes } from "./common/Routes";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const { setFormData } = useContext(FormDataContext);
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    fetch("GET", qualifyUrl(ApiRoutes.INTEGRATIONS.Salesforce.GET_LOG_TYPES)).then((response) => {
      const region = Object.keys(response).map((key) => ({ label: key, value: response[key] }));
      const sortedRegion = [...region];
      sortedRegion.sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });
      setRegions(sortedRegion);
    });
  }, []);
  const handleSubmit = () => {
    if (pollingInterval.value >= 5) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 5 minutes."
      });
    }
  };
  const handleContentType = (val) => {
    const value = { value: val, dirty: false };
    setFormData("logTypes", value);
    setContentTypes(val);
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "log_types",
      id: "log_types",
      options: regions,
      value: contentTypes || "",
      onChange: handleContentType
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above content types will be fetched."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from Salesforce. The smallest allowable interval is 5 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
